export default "__VITE_ASSET__daf88dce__"